import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const InputTextareaTailwindThemes = {
  inputtextarea: {
    root: ({ context }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'm-0 px-1.75 py-1',
        'font-sans text-sm text-black bg-white border border-gray-300 transition-colors duration-200 appearance-none rounded-sm',
        'placeholder:text-fletchers-gray-200',
        {
          'hover:border-fletchers-gray-200 focus:outline-none focus:outline-offset-0 focus:border-fletchers-gray-200':
            !context.disabled,
        },
        { 'opacity-60 select-none pointer-events-none cursor-default': context.disabled },
      ),
    }),
  },
};
